import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSetupNegotiationAgent } from "../../../../services/negotiation/negotiationService";

const ExtendRoundsModal = ({
  item,
  agentSettings,
  onClose,
  company_id,
  fetchSpotData,
  currentFilterPayload,
  onExtended,
}) => {
  const { mutate: setupNegotiationAgent, isPending } = useSetupNegotiationAgent();
  const [additionalRounds, setAdditionalRounds] = useState(3);

  const origin = item?.lane_details?.origin?.location_name;
  const destination = item?.lane_details?.destination?.location_name;
  const currentMaxRounds = agentSettings?.max_rounds_per_transporter || 0;
  const newMaxRounds = currentMaxRounds + additionalRounds;

  const handleExtend = () => {
    setupNegotiationAgent(
      [
        {
          truck_enquiry_id: item?.truck_enquiry_id,
          agent_enabled: true,
          max_rounds_per_transporter: newMaxRounds,
          target_rate: agentSettings?.target_rate,
          walkaway_rate: agentSettings?.walkaway_rate,
          company_id,
        },
      ],
      {
        onSuccess: (res) => {
          const result = Array.isArray(res) ? res[0] : res;
          if (Array.isArray(res) ? result?.status === "ok" : result?.status) {
            toast.success("Negotiation rounds extended successfully");
            onExtended && onExtended();
            if (fetchSpotData && currentFilterPayload) {
              fetchSpotData(currentFilterPayload);
            }
            onClose && onClose();
          } else {
            toast.error(result?.error || result?.message || "Something went wrong");
          }
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  return (
    <div style={{ padding: "8px 4px" }}>
      <div style={{ fontWeight: 700, color: "#393185", fontSize: "15px" }}>
        {origin} → {destination}
      </div>
      <div style={{ color: "#6b7280", fontSize: "13px", marginTop: "8px" }}>
        LoRRI Agent has used all {currentMaxRounds} rounds with the lowest-quote
        transporter. Extending will let it negotiate for additional rounds.
      </div>

      <div style={{ marginTop: "16px" }}>
        <div style={{ fontSize: "11px", fontWeight: 700, color: "#4A5568" }}>
          ADDITIONAL ROUNDS
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
          <button
            type="button"
            className="btn btn-sm"
            style={{ border: "1px solid #cdd3de" }}
            onClick={() => setAdditionalRounds((r) => Math.max(1, r - 1))}
            disabled={isPending}
          >
            −
          </button>
          <span style={{ fontWeight: 700 }}>{additionalRounds}</span>
          <button
            type="button"
            className="btn btn-sm"
            style={{ border: "1px solid #cdd3de" }}
            onClick={() => setAdditionalRounds((r) => r + 1)}
            disabled={isPending}
          >
            +
          </button>
        </div>
        <div style={{ color: "#6b7280", fontSize: "12px", marginTop: "6px" }}>
          New round limit: <b>{newMaxRounds}</b> (currently {currentMaxRounds})
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <button
          type="button"
          className="btn btn-sm"
          style={{ border: "1px solid #cdd3de" }}
          onClick={() => onClose && onClose()}
          disabled={isPending}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm"
          style={{
            background: "#393185",
            color: "#fff",
            fontWeight: 600,
            border: "none",
            padding: "6px 16px",
          }}
          onClick={handleExtend}
          disabled={isPending}
        >
          {isPending ? "Extending…" : "Extend Rounds"}
        </button>
      </div>
    </div>
  );
};

export default ExtendRoundsModal;
